import {
  CalculatedBalanceCollection,
  CalculatedBalanceParams,
  CalculatedBalances,
} from "@bitwarden/web-vault/app/services/store/calculated-balance.collection.abstraction";
import { signal } from "@angular/core";

export class BalanceByTransactionsCalculatedCollection extends CalculatedBalanceCollection {
  protected readonly type = "BalanceByTransactions";
  protected calculations: CalculatedBalances = new Map<string, number>();

  protected _balances = signal<Map<string, number>>(new Map());
  readonly balances = this._balances.asReadonly();

  async updateCalculations(parameters: CalculatedBalanceParams): Promise<void> {
    const isStale = this.staleCheck();
    const balancesByTransactions: Record<string, number> = await this.getBalanceByTransactions(
      parameters.webWorkerQueue,
      parameters.calculatedTransactions,
    );
    if (isStale()) {
      return;
    }
    this.setBalances(balancesByTransactions);
  }

  getCalculations(): CalculatedBalances {
    return this.calculations;
  }

  private setBalances(balancesByTransactions: Record<string, number>): void {
    this.calculations = new Map(Object.entries(balancesByTransactions));
    this._balances.set(this.calculations);
  }

  protected clearCalculations(): void {
    this.calculations.clear();
    this._balances.set(null);
  }

  triggerChanges(): void {}
}
